/* eslint-disable */
import { ReactComponent as ActionPlanElement } from './assets/ActionPlan_icons_Action_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Action } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Action variant="fill" />
 * ```
 */
export const ActionPlan = ActionPlanElement;

import { ReactComponent as AddCrossElement } from './assets/AddCross_icons_Add_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Add } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Add variant="line" />
 * ```
 */
export const AddCross = AddCrossElement;

import { ReactComponent as AddCrossPartialElement } from './assets/AddCrossPartial_icons_Add_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Add } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Add variant="line" />
 * ```
 */
export const AddCrossPartial = AddCrossPartialElement;

import { ReactComponent as AdminIconElement } from './assets/AdminIcon_icons_Administration_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Administration } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Administration variant="line" />
 * ```
 */
export const AdminIcon = AdminIconElement;

import { ReactComponent as AlignmentCenterElement } from './assets/AlignmentCenter_icons_AlignCenter_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AlignCenter } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <AlignCenter variant="line" />
 * ```
 */
export const AlignmentCenter = AlignmentCenterElement;

import { ReactComponent as AlignmentLeftElement } from './assets/AlignmentLeft_icons_AlignLeft_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AlignLeft } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <AlignLeft variant="line" />
 * ```
 */
export const AlignmentLeft = AlignmentLeftElement;

import { ReactComponent as AlignmentRightElement } from './assets/AlignmentRight_icons_AlignRight_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AlignRight } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <AlignRight variant="line" />
 * ```
 */
export const AlignmentRight = AlignmentRightElement;

import { ReactComponent as AlimentaireElement } from './assets/Alimentaire_pictos_SecteurAgroAlim.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecteurAgroAlim } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecteurAgroAlim  />
 * ```
 */
export const Alimentaire = AlimentaireElement;

import { ReactComponent as AnalyseATElement } from './assets/AnalyseAT_icons_Analysis_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Analysis } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Analysis variant="line" />
 * ```
 */
export const AnalyseAT = AnalyseATElement;

import { ReactComponent as AreaElement } from './assets/Area_icons_Area_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Area } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Area variant="line" />
 * ```
 */
export const Area = AreaElement;

import { ReactComponent as ArrowForwardElement } from './assets/ArrowForward_icons_ArrowRight_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ArrowRight } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <ArrowRight variant="line" />
 * ```
 */
export const ArrowForward = ArrowForwardElement;

import { ReactComponent as ArrowInCircleElement } from './assets/ArrowInCircle_pictos_ServicesFleche.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ServicesFleche } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <ServicesFleche  />
 * ```
 */
export const ArrowInCircle = ArrowInCircleElement;

import { ReactComponent as AscendingOrderElement } from './assets/AscendingOrder_icons_SortUp_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SortUp } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <SortUp variant="line" />
 * ```
 */
export const AscendingOrder = AscendingOrderElement;

import { ReactComponent as AttacheCaseElement } from './assets/AttacheCase_icons_Briefcase_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Briefcase } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Briefcase variant="fill" />
 * ```
 */
export const AttacheCase = AttacheCaseElement;

import { ReactComponent as AttacheCaseGreyElement } from './assets/AttacheCaseGrey_icons_Briefcase_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Briefcase } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Briefcase variant="line" />
 * ```
 */
export const AttacheCaseGrey = AttacheCaseGreyElement;

import { ReactComponent as AttacheCaseWhiteElement } from './assets/AttacheCaseWhite_icons_Briefcase_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Briefcase } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Briefcase variant="fill" />
 * ```
 */
export const AttacheCaseWhite = AttacheCaseWhiteElement;

import { ReactComponent as AutomobileElement } from './assets/Automobile_pictos_SecteurAutomobile.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecteurAutomobile } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecteurAutomobile  />
 * ```
 */
export const Automobile = AutomobileElement;

import { ReactComponent as AutreElement } from './assets/Autre_pictos_AnalyseATTechnique.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AnalyseATTechnique } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <AnalyseATTechnique  />
 * ```
 */
export const Autre = AutreElement;

import { ReactComponent as BDPElement } from './assets/BDP_logos_BriefDePoste_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { BriefDePoste } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <BriefDePoste variant="prod" />
 * ```
 */
export const BDP = BDPElement;

import { ReactComponent as BDPBonusIconElement } from './assets/BDPBonusIcon_pictos_PrimesRed.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PrimesRed } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <PrimesRed  />
 * ```
 */
export const BDPBonusIcon = BDPBonusIconElement;

import { ReactComponent as BDPDeleteWarningElement } from './assets/BDPDeleteWarning_headers_DeleteAlerte.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { DeleteAlerte } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <DeleteAlerte  />
 * ```
 */
export const BDPDeleteWarning = BDPDeleteWarningElement;

import { ReactComponent as BDPEnvironmentsElement } from './assets/BDPEnvironments_pictos_EnvironnementMission.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { EnvironnementMission } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <EnvironnementMission  />
 * ```
 */
export const BDPEnvironments = BDPEnvironmentsElement;

import { ReactComponent as BDPExportHeaderElement } from './assets/BDPExportHeader_headers_ExportNavy.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ExportNavy } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <ExportNavy  />
 * ```
 */
export const BDPExportHeader = BDPExportHeaderElement;

import { ReactComponent as BDPHeaderBonusesElement } from './assets/BDPHeaderBonuses_headers_Primes.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Primes } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Primes  />
 * ```
 */
export const BDPHeaderBonuses = BDPHeaderBonusesElement;

import { ReactComponent as BDPHeaderVariablesElement } from './assets/BDPHeaderVariables_headers_Variable.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Variable } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Variable  />
 * ```
 */
export const BDPHeaderVariables = BDPHeaderVariablesElement;

import { ReactComponent as BDPMobileElement } from './assets/BDPMobile_logos_BriefDePoste_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { BriefDePoste } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <BriefDePoste variant="prod" />
 * ```
 */
export const BDPMobile = BDPMobileElement;

import { ReactComponent as BDPUATMobileElement } from './assets/BDPUATMobile_logos_BriefDePoste_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { BriefDePoste } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <BriefDePoste variant="uat" />
 * ```
 */
export const BDPUATMobile = BDPUATMobileElement;

import { ReactComponent as BDPVariableIconElement } from './assets/BDPVariableIcon_pictos_VariableBlue.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { VariableBlue } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <VariableBlue  />
 * ```
 */
export const BDPVariableIcon = BDPVariableIconElement;

import { ReactComponent as BTPElement } from './assets/BTP_pictos_SecteurBtp.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecteurBtp } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecteurBtp  />
 * ```
 */
export const BTP = BTPElement;

import { ReactComponent as BackToElement } from './assets/BackTo_icons_Undo_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Undo } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Undo variant="line" />
 * ```
 */
export const BackTo = BackToElement;

import { ReactComponent as BalloonElement } from './assets/Balloon_headers_FelicitationsBallons.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { FelicitationsBallons } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <FelicitationsBallons  />
 * ```
 */
export const Balloon = BalloonElement;

import { ReactComponent as BarragePhotovoltaiqueElement } from './assets/BarragePhotovoltaique_pictos_SecuBarragePhotovoltaique.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuBarragePhotovoltaique } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuBarragePhotovoltaique  />
 * ```
 */
export const BarragePhotovoltaique = BarragePhotovoltaiqueElement;

import { ReactComponent as BarriereElement } from './assets/Barriere_pictos_SecuBarriere.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuBarriere } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuBarriere  />
 * ```
 */
export const Barriere = BarriereElement;

import { ReactComponent as BarriereLateraleCamionElement } from './assets/BarriereLateraleCamion_pictos_SecuBarriereLateraleCamion.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuBarriereLateraleCamion } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuBarriereLateraleCamion  />
 * ```
 */
export const BarriereLateraleCamion = BarriereLateraleCamionElement;

import { ReactComponent as BaudrierElement } from './assets/Baudrier_pictos_SecuBaudrier.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuBaudrier } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuBaudrier  />
 * ```
 */
export const Baudrier = BaudrierElement;

import { ReactComponent as BellElement } from './assets/Bell_icons_Bell_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Bell } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Bell variant="fill" />
 * ```
 */
export const Bell = BellElement;

import { ReactComponent as BigActionButtonElement } from './assets/BigActionButton_icons_OtherHorizontal_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { OtherHorizontal } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <OtherHorizontal variant="line" />
 * ```
 */
export const BigActionButton = BigActionButtonElement;

import { ReactComponent as BigClockElement } from './assets/BigClock_pictos_AnalyseATTemps.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AnalyseATTemps } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <AnalyseATTemps  />
 * ```
 */
export const BigClock = BigClockElement;

import { ReactComponent as BigGroupElement } from './assets/BigGroup_pictos_ClientsBlue.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ClientsBlue } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <ClientsBlue  />
 * ```
 */
export const BigGroup = BigGroupElement;

import { ReactComponent as BigHistoElement } from './assets/BigHisto_icons_SizeC_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SizeC } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <SizeC variant="line" />
 * ```
 */
export const BigHisto = BigHistoElement;

import { ReactComponent as BigPencilElement } from './assets/BigPencil_pictos_Contrats.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Contrats } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Contrats  />
 * ```
 */
export const BigPencil = BigPencilElement;

import { ReactComponent as BinocularElement } from './assets/Binocular_illustrations_Recherche.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Recherche } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
 *
 * <Recherche  />
 * ```
 */
export const Binocular = BinocularElement;

import { ReactComponent as BinocularFullElement } from './assets/BinocularFull_illustrations_BinocularJaune.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { BinocularJaune } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
 *
 * <BinocularJaune  />
 * ```
 */
export const BinocularFull = BinocularFullElement;

import { ReactComponent as BinocularFullCutElement } from './assets/BinocularFullCut_headers_Validation.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Validation } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Validation  />
 * ```
 */
export const BinocularFullCut = BinocularFullCutElement;

import { ReactComponent as BipReculElement } from './assets/BipRecul_pictos_SecuBipRecul.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuBipRecul } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuBipRecul  />
 * ```
 */
export const BipRecul = BipReculElement;

import { ReactComponent as BlackCircleCheckElement } from './assets/BlackCircleCheck_icons_CircleCheck_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleCheck } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleCheck variant="fill" />
 * ```
 */
export const BlackCircleCheck = BlackCircleCheckElement;

import { ReactComponent as BlueBinocularElement } from './assets/BlueBinocular_illustrations_BinocularBlue.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { BinocularBlue } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
 *
 * <BinocularBlue  />
 * ```
 */
export const BlueBinocular = BlueBinocularElement;

import { ReactComponent as BlueBulletElement } from './assets/BlueBullet_icons_Bullet_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Bullet } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Bullet variant="fill" />
 * ```
 */
export const BlueBullet = BlueBulletElement;

import { ReactComponent as BlueChipElement } from './assets/BlueChip_icons_Circle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Circle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Circle variant="fill" />
 * ```
 */
export const BlueChip = BlueChipElement;

import { ReactComponent as BoldElement } from './assets/Bold_icons_TextBold_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TextBold } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <TextBold variant="line" />
 * ```
 */
export const Bold = BoldElement;

import { ReactComponent as BouchonsElement } from './assets/Bouchons_pictos_SecuBouchons.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuBouchons } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuBouchons  />
 * ```
 */
export const Bouchons = BouchonsElement;

import { ReactComponent as BubbleElement } from './assets/Bubble_icons_Bubbles_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Bubbles } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Bubbles variant="fill" />
 * ```
 */
export const Bubble = BubbleElement;

import { ReactComponent as BulletFillElement } from './assets/BulletFill.svg';
/**
 * @deprecated this icon was not replaced
 */
export const BulletFill = BulletFillElement;

import { ReactComponent as BurgermenuElement } from './assets/Burgermenu_icons_MenuOther_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { MenuOther } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <MenuOther variant="line" />
 * ```
 */
export const Burgermenu = BurgermenuElement;

import { ReactComponent as CalendarElement } from './assets/Calendar_icons_Calendar_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Calendar } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Calendar variant="fill" />
 * ```
 */
export const Calendar = CalendarElement;

import { ReactComponent as CalendarTodayElement } from './assets/CalendarToday_icons_CalendarFocus_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CalendarFocus } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CalendarFocus variant="line" />
 * ```
 */
export const CalendarToday = CalendarTodayElement;

import { ReactComponent as CalendrierElement } from './assets/Calendrier_icons_Calendar_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Calendar } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Calendar variant="line" />
 * ```
 */
export const Calendrier = CalendrierElement;

import { ReactComponent as CardsElement } from './assets/Cards_icons_Cards_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Cards } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Cards variant="fill" />
 * ```
 */
export const Cards = CardsElement;

import { ReactComponent as CarterProtectionElement } from './assets/CarterProtection_pictos_SecuCarterProtection.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuCarterProtection } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuCarterProtection  />
 * ```
 */
export const CarterProtection = CarterProtectionElement;

import { ReactComponent as CasqueElement } from './assets/Casque_pictos_SecuCasque.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuCasque } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuCasque  />
 * ```
 */
export const Casque = CasqueElement;

import { ReactComponent as ChaussuresElement } from './assets/Chaussures_pictos_SecuChaussures.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuChaussures } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuChaussures  />
 * ```
 */
export const Chaussures = ChaussuresElement;

import { ReactComponent as CheckElement } from './assets/Check_icons_Check_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Check } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Check variant="line" />
 * ```
 */
export const Check = CheckElement;

import { ReactComponent as CheckInCircleElement } from './assets/CheckInCircle_icons_CircleCheck_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleCheck } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleCheck variant="fill" />
 * ```
 */
export const CheckInCircle = CheckInCircleElement;

import { ReactComponent as CheckLineElement } from './assets/CheckLine_icons_Check_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Check } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Check variant="line" />
 * ```
 */
export const CheckLine = CheckLineElement;

import { ReactComponent as CheckboxElement } from './assets/Checkbox.svg';
/**
 * @deprecated this icon was not replaced
 */
export const Checkbox = CheckboxElement;

import { ReactComponent as CheckerboardElement } from './assets/Checkerboard_headers_Conclusion.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Conclusion } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Conclusion  />
 * ```
 */
export const Checkerboard = CheckerboardElement;

import { ReactComponent as CheckmarkCircleElement } from './assets/CheckmarkCircle_icons_CircleCheck_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleCheck } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleCheck variant="fill" />
 * ```
 */
export const CheckmarkCircle = CheckmarkCircleElement;

import { ReactComponent as CheckmarkCircleOutlineElement } from './assets/CheckmarkCircleOutline_icons_CircleCheck_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleCheck } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleCheck variant="line" />
 * ```
 */
export const CheckmarkCircleOutline = CheckmarkCircleOutlineElement;

import { ReactComponent as ChevronBottomElement } from './assets/ChevronBottom_icons_NavigateDown_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateDown } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateDown variant="line" />
 * ```
 */
export const ChevronBottom = ChevronBottomElement;

import { ReactComponent as ChevronLeftElement } from './assets/ChevronLeft_icons_NavigateLeft_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateLeft } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateLeft variant="line" />
 * ```
 */
export const ChevronLeft = ChevronLeftElement;

import { ReactComponent as ChevronRightElement } from './assets/ChevronRight_icons_NavigateRight_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateRight } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateRight variant="line" />
 * ```
 */
export const ChevronRight = ChevronRightElement;

import { ReactComponent as ChevronUpElement } from './assets/ChevronUp_icons_NavigateUp_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateUp } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateUp variant="line" />
 * ```
 */
export const ChevronUp = ChevronUpElement;

import { ReactComponent as ChronoElement } from './assets/Chrono_icons_Chrono_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Chrono } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Chrono variant="line" />
 * ```
 */
export const Chrono = ChronoElement;

import { ReactComponent as CircleCheckElement } from './assets/CircleCheck_icons_CircleCheck_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleCheck } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleCheck variant="fill" />
 * ```
 */
export const CircleCheck = CircleCheckElement;

import { ReactComponent as CircleCheckGreenElement } from './assets/CircleCheckGreen_icons_CircleCheck_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleCheck } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleCheck variant="fill" />
 * ```
 */
export const CircleCheckGreen = CircleCheckGreenElement;

import { ReactComponent as CircleCloseElement } from './assets/CircleClose_icons_CircleError_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleError } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleError variant="fill" />
 * ```
 */
export const CircleClose = CircleCloseElement;

import { ReactComponent as CircleErrorElement } from './assets/CircleError_icons_CircleError_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleError } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleError variant="fill" />
 * ```
 */
export const CircleError = CircleErrorElement;

import { ReactComponent as CircleLineElement } from './assets/CircleLine_icons_Circle_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Circle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Circle variant="line" />
 * ```
 */
export const CircleLine = CircleLineElement;

import { ReactComponent as CircleMoinsElement } from './assets/CircleMoins_icons_CircleMinus_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleMinus } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleMinus variant="fill" />
 * ```
 */
export const CircleMoins = CircleMoinsElement;

import { ReactComponent as CircleRandstadElement } from './assets/CircleRandstad_icons_RandstadCircle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RandstadCircle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <RandstadCircle variant="fill" />
 * ```
 */
export const CircleRandstad = CircleRandstadElement;

import { ReactComponent as ClasseIIIHumideElement } from './assets/ClasseIIIHumide_pictos_SecuClasse3Humide.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuClasse3Humide } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuClasse3Humide  />
 * ```
 */
export const ClasseIIIHumide = ClasseIIIHumideElement;

import { ReactComponent as ClientSearchElement } from './assets/ClientSearch_icons_BuildingLoupe_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { BuildingLoupe } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <BuildingLoupe variant="line" />
 * ```
 */
export const ClientSearch = ClientSearchElement;

import { ReactComponent as ClockElement } from './assets/Clock_pictos_AnalyseATTemps.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AnalyseATTemps } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <AnalyseATTemps  />
 * ```
 */
export const Clock = ClockElement;

import { ReactComponent as CloseButtonElement } from './assets/CloseButton_icons_CircleError_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleError } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleError variant="fill" />
 * ```
 */
export const CloseButton = CloseButtonElement;

import { ReactComponent as CloseOldElement } from './assets/CloseOld_icons_Close_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Close } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Close variant="line" />
 * ```
 */
export const CloseOld = CloseOldElement;

import { ReactComponent as ClosePopElement } from './assets/ClosePop_icons_Close_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Close } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Close variant="line" />
 * ```
 */
export const ClosePop = ClosePopElement;

import { ReactComponent as CloseSmallElement } from './assets/CloseSmall_icons_Close_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Close } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Close variant="line" />
 * ```
 */
export const CloseSmall = CloseSmallElement;

import { ReactComponent as CoeurElement } from './assets/Coeur_icons_Favorite_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Favorite } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Favorite variant="line" />
 * ```
 */
export const Coeur = CoeurElement;

import { ReactComponent as CommentBubbleElement } from './assets/CommentBubble_icons_BubblesChat_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { BubblesChat } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <BubblesChat variant="fill" />
 * ```
 */
export const CommentBubble = CommentBubbleElement;

import { ReactComponent as ConnexionElement } from './assets/Connexion_icons_Locked_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Locked } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Locked variant="fill" />
 * ```
 */
export const Connexion = ConnexionElement;

import { ReactComponent as ConsultantElement } from './assets/Consultant_icons_Consultant_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Consultant } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Consultant variant="fill" />
 * ```
 */
export const Consultant = ConsultantElement;

import { ReactComponent as ContinueElement } from './assets/Continue_icons_Finish_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Finish } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Finish variant="line" />
 * ```
 */
export const Continue = ContinueElement;

import { ReactComponent as ContractElement } from './assets/Contract_icons_License_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { License } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <License variant="line" />
 * ```
 */
export const Contract = ContractElement;

import { ReactComponent as ContractGreyElement } from './assets/ContractGrey_icons_License_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { License } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <License variant="line" />
 * ```
 */
export const ContractGrey = ContractGreyElement;

import { ReactComponent as ContractWhiteElement } from './assets/ContractWhite_icons_License_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { License } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <License variant="fill" />
 * ```
 */
export const ContractWhite = ContractWhiteElement;

import { ReactComponent as CopyElement } from './assets/Copy_icons_Duplicata_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Duplicata } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Duplicata variant="fill" />
 * ```
 */
export const Copy = CopyElement;

import { ReactComponent as CrossElement } from './assets/Cross_icons_Close_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Close } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Close variant="line" />
 * ```
 */
export const Cross = CrossElement;

import { ReactComponent as CustomRandyIconElement } from './assets/CustomRandyIcon_logos_Randy_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Randy } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Randy variant="prod" />
 * ```
 */
export const CustomRandyIcon = CustomRandyIconElement;

import { ReactComponent as CustomRandyMobileIconElement } from './assets/CustomRandyMobileIcon_logos_Randy_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Randy } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Randy variant="prod" />
 * ```
 */
export const CustomRandyMobileIcon = CustomRandyMobileIconElement;

import { ReactComponent as CustomRandyProdElement } from './assets/CustomRandyProd_logos_Randy_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Randy } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Randy variant="prod" />
 * ```
 */
export const CustomRandyProd = CustomRandyProdElement;

import { ReactComponent as CustomRandyUATMobileElement } from './assets/CustomRandyUATMobile_logos_Randy_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Randy } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Randy variant="uat" />
 * ```
 */
export const CustomRandyUATMobile = CustomRandyUATMobileElement;

import { ReactComponent as CustomRandyUatElement } from './assets/CustomRandyUat_logos_Randy_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Randy } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Randy variant="uat" />
 * ```
 */
export const CustomRandyUat = CustomRandyUatElement;

import { ReactComponent as CutFingerElement } from './assets/CutFinger_headers_ActionYellow.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ActionYellow } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <ActionYellow  />
 * ```
 */
export const CutFinger = CutFingerElement;

import { ReactComponent as DangerFillRedElement } from './assets/DangerFillRed_icons_Danger_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Danger } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Danger variant="fill" />
 * ```
 */
export const DangerFillRed = DangerFillRedElement;

import { ReactComponent as DangerLineElement } from './assets/DangerLine_icons_Danger_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Danger } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Danger variant="line" />
 * ```
 */
export const DangerLine = DangerLineElement;

import { ReactComponent as DangerOutlineElement } from './assets/DangerOutline_icons_Danger_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Danger } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Danger variant="line" />
 * ```
 */
export const DangerOutline = DangerOutlineElement;

import { ReactComponent as DashboardElement } from './assets/Dashboard_icons_Indicator_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Indicator } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Indicator variant="line" />
 * ```
 */
export const Dashboard = DashboardElement;

import { ReactComponent as DefaultIconElement } from './assets/DefaultIcon_icons_Circle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Circle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Circle variant="fill" />
 * ```
 */
export const DefaultIcon = DefaultIconElement;

import { ReactComponent as DescendingOrderElement } from './assets/DescendingOrder_icons_SortDown_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SortDown } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <SortDown variant="line" />
 * ```
 */
export const DescendingOrder = DescendingOrderElement;

import { ReactComponent as DisableCheckCheckboxElement } from './assets/DisableCheckCheckbox_icons_Check_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Check } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Check variant="fill" />
 * ```
 */
export const DisableCheckCheckbox = DisableCheckCheckboxElement;

import { ReactComponent as DisabledCheckboxElement } from './assets/DisabledCheckbox.svg';
/**
 * @deprecated this icon was not replaced
 */
export const DisabledCheckbox = DisabledCheckboxElement;

import { ReactComponent as DocumentElement } from './assets/Document_icons_Document_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Document } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Document variant="fill" />
 * ```
 */
export const Document = DocumentElement;

import { ReactComponent as DocumentFileElement } from './assets/DocumentFile_icons_Document_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Document } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Document variant="line" />
 * ```
 */
export const DocumentFile = DocumentFileElement;

import { ReactComponent as DocumentPDFElement } from './assets/DocumentPDF_icons_DocumentPdf_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { DocumentPdf } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <DocumentPdf variant="line" />
 * ```
 */
export const DocumentPDF = DocumentPDFElement;

import { ReactComponent as DoubleBulleElement } from './assets/DoubleBulle_icons_DoubleCircle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { DoubleCircle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <DoubleCircle variant="fill" />
 * ```
 */
export const DoubleBulle = DoubleBulleElement;

import { ReactComponent as DoubleCommandeElement } from './assets/DoubleCommande_pictos_SecuDoubleCommande.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuDoubleCommande } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuDoubleCommande  />
 * ```
 */
export const DoubleCommande = DoubleCommandeElement;

import { ReactComponent as DownArrowElement } from './assets/DownArrow_icons_TriangleDown_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TriangleDown } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <TriangleDown variant="fill" />
 * ```
 */
export const DownArrow = DownArrowElement;

import { ReactComponent as DownloadLineElement } from './assets/DownloadLine_icons_Download_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Download } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Download variant="line" />
 * ```
 */
export const DownloadLine = DownloadLineElement;

import { ReactComponent as DragIconElement } from './assets/DragIcon_icons_LineHorizontalDouble_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { LineHorizontalDouble } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <LineHorizontalDouble variant="line" />
 * ```
 */
export const DragIcon = DragIconElement;

import { ReactComponent as DrawingPencilElement } from './assets/DrawingPencil_headers_Modifiy.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Modifiy } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Modifiy  />
 * ```
 */
export const DrawingPencil = DrawingPencilElement;

import { ReactComponent as DuplicataFillElement } from './assets/DuplicataFill_icons_Duplicata_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Duplicata } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Duplicata variant="fill" />
 * ```
 */
export const DuplicataFill = DuplicataFillElement;

import { ReactComponent as DuplicataLineElement } from './assets/DuplicataLine_icons_Duplicata_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Duplicata } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Duplicata variant="line" />
 * ```
 */
export const DuplicataLine = DuplicataLineElement;

import { ReactComponent as EDPIconElement } from './assets/EDPIcon_logos_EtudeDePoste_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { EtudeDePoste } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <EtudeDePoste variant="prod" />
 * ```
 */
export const EDPIcon = EDPIconElement;

import { ReactComponent as EDPMobileIconElement } from './assets/EDPMobileIcon_logos_EtudeDePoste_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { EtudeDePoste } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <EtudeDePoste variant="prod" />
 * ```
 */
export const EDPMobileIcon = EDPMobileIconElement;

import { ReactComponent as EDPProdElement } from './assets/EDPProd_logos_EtudeDePoste_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { EtudeDePoste } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <EtudeDePoste variant="prod" />
 * ```
 */
export const EDPProd = EDPProdElement;

import { ReactComponent as EDPUATMobileElement } from './assets/EDPUATMobile_logos_EtudeDePoste_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { EtudeDePoste } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <EtudeDePoste variant="uat" />
 * ```
 */
export const EDPUATMobile = EDPUATMobileElement;

import { ReactComponent as EDPUatElement } from './assets/EDPUat_logos_EtudeDePoste_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { EtudeDePoste } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <EtudeDePoste variant="uat" />
 * ```
 */
export const EDPUat = EDPUatElement;

import { ReactComponent as EmailElement } from './assets/Email_icons_Email_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Email } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Email variant="fill" />
 * ```
 */
export const Email = EmailElement;

import { ReactComponent as EmailRoundElement } from './assets/EmailRound.svg';
/**
 * @deprecated this icon was not replaced
 */
export const EmailRound = EmailRoundElement;

import { ReactComponent as EmptyCheckboxElement } from './assets/EmptyCheckbox.svg';
/**
 * @deprecated this icon was not replaced
 */
export const EmptyCheckbox = EmptyCheckboxElement;

import { ReactComponent as EncoffrementMachineBruyanteElement } from './assets/EncoffrementMachineBruyante_pictos_SecuEncoffrementMachineBruyante.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuEncoffrementMachineBruyante } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuEncoffrementMachineBruyante  />
 * ```
 */
export const EncoffrementMachineBruyante = EncoffrementMachineBruyanteElement;

import { ReactComponent as EnvironmentsIconElement } from './assets/EnvironmentsIcon_pictos_EnvironnementComp.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { EnvironnementComp } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <EnvironnementComp  />
 * ```
 */
export const EnvironmentsIcon = EnvironmentsIconElement;

import { ReactComponent as ErrorCheckboxElement } from './assets/ErrorCheckbox.svg';
/**
 * @deprecated this icon was not replaced
 */
export const ErrorCheckbox = ErrorCheckboxElement;

import { ReactComponent as EuroElement } from './assets/Euro_icons_Euro_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Euro } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Euro variant="line" />
 * ```
 */
export const Euro = EuroElement;

import { ReactComponent as EuroSignElement } from './assets/EuroSign_icons_Euro_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Euro } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Euro variant="line" />
 * ```
 */
export const EuroSign = EuroSignElement;

import { ReactComponent as ExpandElement } from './assets/Expand_icons_Expand_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Expand } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Expand variant="line" />
 * ```
 */
export const Expand = ExpandElement;

import { ReactComponent as ExperienceElement } from './assets/Experience_headers_Experience.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Experience } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Experience  />
 * ```
 */
export const Experience = ExperienceElement;

import { ReactComponent as ExportHeaderElement } from './assets/ExportHeader_headers_ExportGreenish.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ExportGreenish } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <ExportGreenish  />
 * ```
 */
export const ExportHeader = ExportHeaderElement;

import { ReactComponent as ExtendElement } from './assets/Extend_icons_Finish_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Finish } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Finish variant="line" />
 * ```
 */
export const Extend = ExtendElement;

import { ReactComponent as EyeElement } from './assets/Eye_icons_Eye_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Eye } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Eye variant="fill" />
 * ```
 */
export const Eye = EyeElement;

import { ReactComponent as EyeBigElement } from './assets/EyeBig_icons_Eye_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Eye } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Eye variant="fill" />
 * ```
 */
export const EyeBig = EyeBigElement;

import { ReactComponent as EyeLineElement } from './assets/EyeLine_icons_Eye_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Eye } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Eye variant="line" />
 * ```
 */
export const EyeLine = EyeLineElement;

import { ReactComponent as FamilyElement } from './assets/Family_icons_Family_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Family } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Family variant="fill" />
 * ```
 */
export const Family = FamilyElement;

import { ReactComponent as FavElement } from './assets/Fav_icons_Favorite_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Favorite } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Favorite variant="line" />
 * ```
 */
export const Fav = FavElement;

import { ReactComponent as FavoriteFillElement } from './assets/FavoriteFill_icons_Favorite_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Favorite } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Favorite variant="fill" />
 * ```
 */
export const FavoriteFill = FavoriteFillElement;

import { ReactComponent as FavoriteLineElement } from './assets/FavoriteLine_icons_Favorite_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Favorite } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Favorite variant="line" />
 * ```
 */
export const FavoriteLine = FavoriteLineElement;

import { ReactComponent as FiletProtectionElement } from './assets/FiletProtection_pictos_SecuFiletProtection.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuFiletProtection } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuFiletProtection  />
 * ```
 */
export const FiletProtection = FiletProtectionElement;

import { ReactComponent as FilterElement } from './assets/Filter_headers_Filtres.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Filtres } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Filtres  />
 * ```
 */
export const Filter = FilterElement;

import { ReactComponent as FilterFillElement } from './assets/FilterFill_icons_Filter_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Filter } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Filter variant="fill" />
 * ```
 */
export const FilterFill = FilterFillElement;

import { ReactComponent as FilterLineElement } from './assets/FilterLine_icons_Filter_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Filter } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Filter variant="line" />
 * ```
 */
export const FilterLine = FilterLineElement;

import { ReactComponent as FiltersElement } from './assets/Filters_icons_Parameters_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Parameters } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Parameters variant="line" />
 * ```
 */
export const Filters = FiltersElement;

import { ReactComponent as FinanceElement } from './assets/Finance_pictos_Finance.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Finance } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Finance  />
 * ```
 */
export const Finance = FinanceElement;

import { ReactComponent as FindElement } from './assets/Find_icons_FindPeople_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { FindPeople } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <FindPeople variant="fill" />
 * ```
 */
export const Find = FindElement;

import { ReactComponent as FindPeopleElement } from './assets/FindPeople_icons_FindPeople_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { FindPeople } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <FindPeople variant="fill" />
 * ```
 */
export const FindPeople = FindPeopleElement;

import { ReactComponent as FitScreenElement } from './assets/FitScreen_icons_FitScreen_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { FitScreen } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <FitScreen variant="line" />
 * ```
 */
export const FitScreen = FitScreenElement;

import { ReactComponent as FlagArabiaElement } from './assets/FlagArabia_flags_SA.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SA } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <SA  />
 * ```
 */
export const FlagArabia = FlagArabiaElement;

import { ReactComponent as FlagChinaElement } from './assets/FlagChina_flags_CN.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CN } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <CN  />
 * ```
 */
export const FlagChina = FlagChinaElement;

import { ReactComponent as FlagChineseCantoneseElement } from './assets/FlagChineseCantonese_flags_CNyue.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CNyue } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <CNyue  />
 * ```
 */
export const FlagChineseCantonese = FlagChineseCantoneseElement;

import { ReactComponent as FlagChineseMandarinElement } from './assets/FlagChineseMandarin_flags_CNcmn.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CNcmn } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <CNcmn  />
 * ```
 */
export const FlagChineseMandarin = FlagChineseMandarinElement;

import { ReactComponent as FlagCzechElement } from './assets/FlagCzech_flags_CZ.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CZ } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <CZ  />
 * ```
 */
export const FlagCzech = FlagCzechElement;

import { ReactComponent as FlagDanemarkElement } from './assets/FlagDanemark_flags_DK.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { DK } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <DK  />
 * ```
 */
export const FlagDanemark = FlagDanemarkElement;

import { ReactComponent as FlagFinlandElement } from './assets/FlagFinland_flags_FI.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { FI } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <FI  />
 * ```
 */
export const FlagFinland = FlagFinlandElement;

import { ReactComponent as FlagFlemishElement } from './assets/FlagFlemish_flags_BEnl.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { BEnl } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <BEnl  />
 * ```
 */
export const FlagFlemish = FlagFlemishElement;

import { ReactComponent as FlagFranceElement } from './assets/FlagFrance_flags_FR.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { FR } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <FR  />
 * ```
 */
export const FlagFrance = FlagFranceElement;

import { ReactComponent as FlagGermanyElement } from './assets/FlagGermany_flags_DE.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { DE } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <DE  />
 * ```
 */
export const FlagGermany = FlagGermanyElement;

import { ReactComponent as FlagHungaryElement } from './assets/FlagHungary_flags_HU.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { HU } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <HU  />
 * ```
 */
export const FlagHungary = FlagHungaryElement;

import { ReactComponent as FlagItalyElement } from './assets/FlagItaly_flags_IT.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { IT } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <IT  />
 * ```
 */
export const FlagItaly = FlagItalyElement;

import { ReactComponent as FlagJapanElement } from './assets/FlagJapan_flags_JP.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { JP } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <JP  />
 * ```
 */
export const FlagJapan = FlagJapanElement;

import { ReactComponent as FlagKoreaElement } from './assets/FlagKorea_flags_KR.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { KR } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <KR  />
 * ```
 */
export const FlagKorea = FlagKoreaElement;

import { ReactComponent as FlagMalaysiaElement } from './assets/FlagMalaysia_flags_MY.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { MY } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <MY  />
 * ```
 */
export const FlagMalaysia = FlagMalaysiaElement;

import { ReactComponent as FlagNetherlandsElement } from './assets/FlagNetherlands_flags_NL.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NL } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <NL  />
 * ```
 */
export const FlagNetherlands = FlagNetherlandsElement;

import { ReactComponent as FlagNorwayElement } from './assets/FlagNorway_flags_NO.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NO } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <NO  />
 * ```
 */
export const FlagNorway = FlagNorwayElement;

import { ReactComponent as FlagPolandElement } from './assets/FlagPoland_flags_PL.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PL } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <PL  />
 * ```
 */
export const FlagPoland = FlagPolandElement;

import { ReactComponent as FlagPortugalElement } from './assets/FlagPortugal_flags_PT.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PT } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <PT  />
 * ```
 */
export const FlagPortugal = FlagPortugalElement;

import { ReactComponent as FlagRomaniaElement } from './assets/FlagRomania_flags_RO.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RO } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <RO  />
 * ```
 */
export const FlagRomania = FlagRomaniaElement;

import { ReactComponent as FlagRussiaElement } from './assets/FlagRussia_flags_RU.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RU } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <RU  />
 * ```
 */
export const FlagRussia = FlagRussiaElement;

import { ReactComponent as FlagSerbiaElement } from './assets/FlagSerbia_flags_CS.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CS } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <CS  />
 * ```
 */
export const FlagSerbia = FlagSerbiaElement;

import { ReactComponent as FlagSpainElement } from './assets/FlagSpain_flags_ES.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ES } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <ES  />
 * ```
 */
export const FlagSpain = FlagSpainElement;

import { ReactComponent as FlagSwedenElement } from './assets/FlagSweden_flags_SE.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SE } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <SE  />
 * ```
 */
export const FlagSweden = FlagSwedenElement;

import { ReactComponent as FlagSwissElement } from './assets/FlagSwiss_flags_CH.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CH } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <CH  />
 * ```
 */
export const FlagSwiss = FlagSwissElement;

import { ReactComponent as FlagThailandElement } from './assets/FlagThailand_flags_TH.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TH } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <TH  />
 * ```
 */
export const FlagThailand = FlagThailandElement;

import { ReactComponent as FlagTurkeyElement } from './assets/FlagTurkey_flags_TR.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TR } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <TR  />
 * ```
 */
export const FlagTurkey = FlagTurkeyElement;

import { ReactComponent as FlagUKElement } from './assets/FlagUK_flags_GB.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { GB } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <GB  />
 * ```
 */
export const FlagUK = FlagUKElement;

import { ReactComponent as FlagUkrainElement } from './assets/FlagUkrain_flags_UA.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { UA } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <UA  />
 * ```
 */
export const FlagUkrain = FlagUkrainElement;

import { ReactComponent as FlagVietnamElement } from './assets/FlagVietnam_flags_VN.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { VN } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <VN  />
 * ```
 */
export const FlagVietnam = FlagVietnamElement;

import { ReactComponent as FlagYougoslaviaElement } from './assets/FlagYougoslavia_flags_YU.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { YU } from '@randstad-lean-mobile-factory/react-assets/dist/flags';
 *
 * <YU  />
 * ```
 */
export const FlagYougoslavia = FlagYougoslaviaElement;

import { ReactComponent as FlashIconElement } from './assets/FlashIcon_logos_Flash_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Flash } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Flash variant="prod" />
 * ```
 */
export const FlashIcon = FlashIconElement;

import { ReactComponent as FlashMobileIconElement } from './assets/FlashMobileIcon_logos_Flash_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Flash } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Flash variant="prod" />
 * ```
 */
export const FlashMobileIcon = FlashMobileIconElement;

import { ReactComponent as FlashProdElement } from './assets/FlashProd_logos_Flash_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Flash } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Flash variant="prod" />
 * ```
 */
export const FlashProd = FlashProdElement;

import { ReactComponent as FlashUATMobileElement } from './assets/FlashUATMobile_logos_Flash_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Flash } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Flash variant="uat" />
 * ```
 */
export const FlashUATMobile = FlashUATMobileElement;

import { ReactComponent as FlashUatElement } from './assets/FlashUat_logos_Flash_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Flash } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Flash variant="uat" />
 * ```
 */
export const FlashUat = FlashUatElement;

import { ReactComponent as FlecheBackElement } from './assets/FlecheBack_icons_ArrowLeft_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ArrowLeft } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <ArrowLeft variant="line" />
 * ```
 */
export const FlecheBack = FlecheBackElement;

import { ReactComponent as FlecheBottomElement } from './assets/FlecheBottom_icons_NavigateDown_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateDown } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateDown variant="line" />
 * ```
 */
export const FlecheBottom = FlecheBottomElement;

import { ReactComponent as FlecheGoElement } from './assets/FlecheGo_icons_ArrowRight_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ArrowRight } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <ArrowRight variant="line" />
 * ```
 */
export const FlecheGo = FlecheGoElement;

import { ReactComponent as FlecheLeftElement } from './assets/FlecheLeft_icons_NavigateLeft_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateLeft } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateLeft variant="line" />
 * ```
 */
export const FlecheLeft = FlecheLeftElement;

import { ReactComponent as FlecheRightElement } from './assets/FlecheRight_icons_NavigateLeft_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateLeft } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateLeft variant="line" />
 * ```
 */
export const FlecheRight = FlecheRightElement;

import { ReactComponent as FlecheUpElement } from './assets/FlecheUp_icons_NavigateUp_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateUp } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateUp variant="line" />
 * ```
 */
export const FlecheUp = FlecheUpElement;

import { ReactComponent as FlechesPigeElement } from './assets/FlechesPige_illustrations_Pige.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Pige } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
 *
 * <Pige  />
 * ```
 */
export const FlechesPige = FlechesPigeElement;

import { ReactComponent as FlowIconElement } from './assets/FlowIcon.svg';
/**
 * @deprecated this icon was not replaced
 */
export const FlowIcon = FlowIconElement;

import { ReactComponent as FluxElement } from './assets/Flux_icons_Flux_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Flux } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Flux variant="line" />
 * ```
 */
export const Flux = FluxElement;

import { ReactComponent as FolderElement } from './assets/Folder_icons_Folder_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Folder } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Folder variant="line" />
 * ```
 */
export const Folder = FolderElement;

import { ReactComponent as GantsElement } from './assets/Gants_pictos_SecuGants.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuGants } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuGants  />
 * ```
 */
export const Gants = GantsElement;

import { ReactComponent as GardeCorpsElement } from './assets/GardeCorps_pictos_SecuGardeCorps.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuGardeCorps } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuGardeCorps  />
 * ```
 */
export const GardeCorps = GardeCorpsElement;

import { ReactComponent as GearElement } from './assets/Gear_icons_Settings_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Settings } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Settings variant="fill" />
 * ```
 */
export const Gear = GearElement;

import { ReactComponent as GoBackArrowElement } from './assets/GoBackArrow_icons_ArrowLeft_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ArrowLeft } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <ArrowLeft variant="line" />
 * ```
 */
export const GoBackArrow = GoBackArrowElement;

import { ReactComponent as GreenBulletElement } from './assets/GreenBullet_icons_Bullet_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Bullet } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Bullet variant="fill" />
 * ```
 */
export const GreenBullet = GreenBulletElement;

import { ReactComponent as GreenChipElement } from './assets/GreenChip_icons_Circle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Circle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Circle variant="fill" />
 * ```
 */
export const GreenChip = GreenChipElement;

import { ReactComponent as GreenDarkBulletElement } from './assets/GreenDarkBullet_icons_Circle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Circle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Circle variant="fill" />
 * ```
 */
export const GreenDarkBullet = GreenDarkBulletElement;

import { ReactComponent as GridElement } from './assets/Grid_icons_Cards_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Cards } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Cards variant="line" />
 * ```
 */
export const Grid = GridElement;

import { ReactComponent as GridCardMoreElement } from './assets/GridCardMore_icons_CircleAdd_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleAdd } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleAdd variant="fill" />
 * ```
 */
export const GridCardMore = GridCardMoreElement;

import { ReactComponent as GroupElement } from './assets/Group_pictos_ClientsBlue.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ClientsBlue } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <ClientsBlue  />
 * ```
 */
export const Group = GroupElement;

import { ReactComponent as GyrophareEnginElement } from './assets/GyrophareEngin_pictos_SecuGyrophareEngin.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuGyrophareEngin } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuGyrophareEngin  />
 * ```
 */
export const GyrophareEngin = GyrophareEnginElement;

import { ReactComponent as HalfCheckBoxElement } from './assets/HalfCheckBox_icons_Minus_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Minus } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Minus variant="fill" />
 * ```
 */
export const HalfCheckBox = HalfCheckBoxElement;

import { ReactComponent as HeaderFinActionElement } from './assets/HeaderFinAction_headers_FinActionJaune.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { FinActionJaune } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <FinActionJaune  />
 * ```
 */
export const HeaderFinAction = HeaderFinActionElement;

import { ReactComponent as HeaderMissionElement } from './assets/HeaderMission_headers_Missions.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Missions } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Missions  />
 * ```
 */
export const HeaderMission = HeaderMissionElement;

import { ReactComponent as HelmetElement } from './assets/Helmet_icons_Helmet_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Helmet } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Helmet variant="fill" />
 * ```
 */
export const Helmet = HelmetElement;

import { ReactComponent as HighVoltageElement } from './assets/HighVoltage_pictos_HabilitationElecB.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { HabilitationElecB } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <HabilitationElecB  />
 * ```
 */
export const HighVoltage = HighVoltageElement;

import { ReactComponent as HighlightedAppBackgroundElement } from './assets/HighlightedAppBackground.svg';
/**
 * @deprecated this icon was not replaced
 */
export const HighlightedAppBackground = HighlightedAppBackgroundElement;

import { ReactComponent as HotellerieElement } from './assets/Hotellerie_pictos_SecteurHotelRestauration.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecteurHotelRestauration } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecteurHotelRestauration  />
 * ```
 */
export const Hotellerie = HotellerieElement;

import { ReactComponent as HotteAspiranteElement } from './assets/HotteAspirante_pictos_SecuHotteAspirante.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuHotteAspirante } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuHotteAspirante  />
 * ```
 */
export const HotteAspirante = HotteAspiranteElement;

import { ReactComponent as ITMobileProdElement } from './assets/ITMobileProd_logos_AideIT_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AideIT } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <AideIT variant="prod" />
 * ```
 */
export const ITMobileProd = ITMobileProdElement;

import { ReactComponent as ITMobileUatElement } from './assets/ITMobileUat_logos_AideIT_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AideIT } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <AideIT variant="prod" />
 * ```
 */
export const ITMobileUat = ITMobileUatElement;

import { ReactComponent as ITProdElement } from './assets/ITProd_logos_AideIT_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AideIT } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <AideIT variant="prod" />
 * ```
 */
export const ITProd = ITProdElement;

import { ReactComponent as ITUatElement } from './assets/ITUat_logos_AideIT_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { AideIT } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <AideIT variant="uat" />
 * ```
 */
export const ITUat = ITUatElement;

import { ReactComponent as IdCardElement } from './assets/IdCard_icons_Badge_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Badge } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Badge variant="line" />
 * ```
 */
export const IdCard = IdCardElement;

import { ReactComponent as IllusBDPEmailElement } from './assets/IllusBDPEmail_headers_Email.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Email } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Email  />
 * ```
 */
export const IllusBDPEmail = IllusBDPEmailElement;

import { ReactComponent as IllusBDPHeaderCompetitorElement } from './assets/IllusBDPHeaderCompetitor_headers_Challenger.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Challenger } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Challenger  />
 * ```
 */
export const IllusBDPHeaderCompetitor = IllusBDPHeaderCompetitorElement;

import { ReactComponent as IllusEDPBonusElement } from './assets/IllusEDPBonus_headers_ActionNavy.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ActionNavy } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <ActionNavy  />
 * ```
 */
export const IllusEDPBonus = IllusEDPBonusElement;

import { ReactComponent as IllusEscalierElement } from './assets/IllusEscalier_illustrations_ServerErrorWhite.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ServerErrorWhite } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
 *
 * <ServerErrorWhite  />
 * ```
 */
export const IllusEscalier = IllusEscalierElement;

import { ReactComponent as IllusEscalierYellowElement } from './assets/IllusEscalierYellow_illustrations_ServerErrorYellow.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ServerErrorYellow } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
 *
 * <ServerErrorYellow  />
 * ```
 */
export const IllusEscalierYellow = IllusEscalierYellowElement;

import { ReactComponent as IllusFlashEmailElement } from './assets/IllusFlashEmail.svg';
/**
 * @deprecated this icon was not replaced
 */
export const IllusFlashEmail = IllusFlashEmailElement;

import { ReactComponent as IllusFlashSMSElement } from './assets/IllusFlashSMS.svg';
/**
 * @deprecated this icon was not replaced
 */
export const IllusFlashSMS = IllusFlashSMSElement;

import { ReactComponent as IllusFlashTelephoneElement } from './assets/IllusFlashTelephone.svg';
/**
 * @deprecated this icon was not replaced
 */
export const IllusFlashTelephone = IllusFlashTelephoneElement;

import { ReactComponent as IllusFlashYouplanDetailElement } from './assets/IllusFlashYouplanDetail_headers_Details.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Details } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Details  />
 * ```
 */
export const IllusFlashYouplanDetail = IllusFlashYouplanDetailElement;

import { ReactComponent as IllusRLCACESElement } from './assets/IllusRLCACES_headers_Caces.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Caces } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Caces  />
 * ```
 */
export const IllusRLCACES = IllusRLCACESElement;

import { ReactComponent as IllusRLCACESSmallElement } from './assets/IllusRLCACESSmall_pictos_Caces.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Caces } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Caces  />
 * ```
 */
export const IllusRLCACESSmall = IllusRLCACESSmallElement;

import { ReactComponent as IllusRLCalendarElement } from './assets/IllusRLCalendar_headers_Disponibilites.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Disponibilites } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Disponibilites  />
 * ```
 */
export const IllusRLCalendar = IllusRLCalendarElement;

import { ReactComponent as IllusRLCalendarSmallElement } from './assets/IllusRLCalendarSmall_pictos_Dispo.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Dispo } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Dispo  />
 * ```
 */
export const IllusRLCalendarSmall = IllusRLCalendarSmallElement;

import { ReactComponent as IllusRLCompanyElement } from './assets/IllusRLCompany_headers_Comptes.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Comptes } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Comptes  />
 * ```
 */
export const IllusRLCompany = IllusRLCompanyElement;

import { ReactComponent as IllusRLCompanySmallElement } from './assets/IllusRLCompanySmall_pictos_Comptes.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Comptes } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Comptes  />
 * ```
 */
export const IllusRLCompanySmall = IllusRLCompanySmallElement;

import { ReactComponent as IllusRLDiplomaElement } from './assets/IllusRLDiploma_headers_Diplomes.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Diplomes } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Diplomes  />
 * ```
 */
export const IllusRLDiploma = IllusRLDiplomaElement;

import { ReactComponent as IllusRLDiplomaSmallElement } from './assets/IllusRLDiplomaSmall_pictos_DiplomesJaune.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { DiplomesJaune } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <DiplomesJaune  />
 * ```
 */
export const IllusRLDiplomaSmall = IllusRLDiplomaSmallElement;

import { ReactComponent as IllusRLHabilitationsElement } from './assets/IllusRLHabilitations_headers_HabilitationsJaune.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { HabilitationsJaune } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <HabilitationsJaune  />
 * ```
 */
export const IllusRLHabilitations = IllusRLHabilitationsElement;

import { ReactComponent as IllusRLHabilitationsSmallElement } from './assets/IllusRLHabilitationsSmall_pictos_Habilitations.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Habilitations } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Habilitations  />
 * ```
 */
export const IllusRLHabilitationsSmall = IllusRLHabilitationsSmallElement;

import { ReactComponent as IllusRLKeywordElement } from './assets/IllusRLKeyword_headers_MotsClefs.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { MotsClefs } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <MotsClefs  />
 * ```
 */
export const IllusRLKeyword = IllusRLKeywordElement;

import { ReactComponent as IllusRLKeywordSmallElement } from './assets/IllusRLKeywordSmall_pictos_Contrats.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Contrats } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Contrats  />
 * ```
 */
export const IllusRLKeywordSmall = IllusRLKeywordSmallElement;

import { ReactComponent as IllusRLLanguageElement } from './assets/IllusRLLanguage_headers_Langues.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Langues } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Langues  />
 * ```
 */
export const IllusRLLanguage = IllusRLLanguageElement;

import { ReactComponent as IllusRLLanguageSmallElement } from './assets/IllusRLLanguageSmall_pictos_Alphabets.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Alphabets } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Alphabets  />
 * ```
 */
export const IllusRLLanguageSmall = IllusRLLanguageSmallElement;

import { ReactComponent as IllusRLLicenseElement } from './assets/IllusRLLicense_headers_Permis.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Permis } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Permis  />
 * ```
 */
export const IllusRLLicense = IllusRLLicenseElement;

import { ReactComponent as IllusRLLicenseSmallElement } from './assets/IllusRLLicenseSmall_pictos_Permis.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Permis } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Permis  />
 * ```
 */
export const IllusRLLicenseSmall = IllusRLLicenseSmallElement;

import { ReactComponent as IllusRLPotentialElement } from './assets/IllusRLPotential_headers_Potentiels.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Potentiels } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Potentiels  />
 * ```
 */
export const IllusRLPotential = IllusRLPotentialElement;

import { ReactComponent as IllusRLPotentialSmallElement } from './assets/IllusRLPotentialSmall_pictos_PostesPotentiel.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PostesPotentiel } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <PostesPotentiel  />
 * ```
 */
export const IllusRLPotentialSmall = IllusRLPotentialSmallElement;

import { ReactComponent as IllusRLQualificationElement } from './assets/IllusRLQualification_headers_Qualifications.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Qualifications } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Qualifications  />
 * ```
 */
export const IllusRLQualification = IllusRLQualificationElement;

import { ReactComponent as IllusRLQualificationSmallElement } from './assets/IllusRLQualificationSmall_pictos_Qualifications.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Qualifications } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Qualifications  />
 * ```
 */
export const IllusRLQualificationSmall = IllusRLQualificationSmallElement;

import { ReactComponent as IllusRLServiceElement } from './assets/IllusRLService_headers_Services.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Services } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Services  />
 * ```
 */
export const IllusRLService = IllusRLServiceElement;

import { ReactComponent as IllusRLServiceSmallElement } from './assets/IllusRLServiceSmall_pictos_Services.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Services } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Services  />
 * ```
 */
export const IllusRLServiceSmall = IllusRLServiceSmallElement;

import { ReactComponent as IllusRLSkillsElement } from './assets/IllusRLSkills_headers_Competences.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Competences } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Competences  />
 * ```
 */
export const IllusRLSkills = IllusRLSkillsElement;

import { ReactComponent as IllusRLSkillsSmallElement } from './assets/IllusRLSkillsSmall_pictos_CompetencesJaune.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CompetencesJaune } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <CompetencesJaune  />
 * ```
 */
export const IllusRLSkillsSmall = IllusRLSkillsSmallElement;

import { ReactComponent as IllusRLVillesElement } from './assets/IllusRLVilles_headers_Villes.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Villes } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Villes  />
 * ```
 */
export const IllusRLVilles = IllusRLVillesElement;

import { ReactComponent as IllusRLVillesSmallElement } from './assets/IllusRLVillesSmall_pictos_Villes.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Villes } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Villes  />
 * ```
 */
export const IllusRLVillesSmall = IllusRLVillesSmallElement;

import { ReactComponent as IllusSignElement } from './assets/IllusSign_headers_Signature.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Signature } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Signature  />
 * ```
 */
export const IllusSign = IllusSignElement;

import { ReactComponent as IllusTdPHistoryElement } from './assets/IllusTdPHistory_headers_Liste.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Liste } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Liste  />
 * ```
 */
export const IllusTdPHistory = IllusTdPHistoryElement;

import { ReactComponent as IllusTdpAbsenceElement } from './assets/IllusTdpAbsence_headers_Absence.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Absence } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Absence  />
 * ```
 */
export const IllusTdpAbsence = IllusTdpAbsenceElement;

import { ReactComponent as IllusTdpHeaderPoursuivreElement } from './assets/IllusTdpHeaderPoursuivre.svg';
/**
 * @deprecated this icon was not replaced
 */
export const IllusTdpHeaderPoursuivre = IllusTdpHeaderPoursuivreElement;

import { ReactComponent as IllusTdpUniteElement } from './assets/IllusTdpUnite.svg';
/**
 * @deprecated this icon was not replaced
 */
export const IllusTdpUnite = IllusTdpUniteElement;

import { ReactComponent as IllusTransfertElement } from './assets/IllusTransfert_headers_Transfert.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Transfert } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Transfert  />
 * ```
 */
export const IllusTransfert = IllusTransfertElement;

import { ReactComponent as IllusUnitHeaderElement } from './assets/IllusUnitHeader_headers_UnitesGreenish.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { UnitesGreenish } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <UnitesGreenish  />
 * ```
 */
export const IllusUnitHeader = IllusUnitHeaderElement;

import { ReactComponent as ImageElement } from './assets/Image_icons_DocumentImage_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { DocumentImage } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <DocumentImage variant="line" />
 * ```
 */
export const Image = ImageElement;

import { ReactComponent as IndustrieElement } from './assets/Industrie_pictos_Client.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Client } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Client  />
 * ```
 */
export const Industrie = IndustrieElement;

import { ReactComponent as InfoElement } from './assets/Info_icons_Information_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Information } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Information variant="line" />
 * ```
 */
export const Info = InfoElement;

import { ReactComponent as InfoFullElement } from './assets/InfoFull_icons_Information_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Information } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Information variant="fill" />
 * ```
 */
export const InfoFull = InfoFullElement;

import { ReactComponent as InfoOutlineElement } from './assets/InfoOutline_icons_Information_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Information } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Information variant="line" />
 * ```
 */
export const InfoOutline = InfoOutlineElement;

import { ReactComponent as InformatiqueElement } from './assets/Informatique_pictos_Informatique.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Informatique } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Informatique  />
 * ```
 */
export const Informatique = InformatiqueElement;

import { ReactComponent as InsonorisationLocalElement } from './assets/InsonorisationLocal_pictos_SecuInsonorisationLocal.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuInsonorisationLocal } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuInsonorisationLocal  />
 * ```
 */
export const InsonorisationLocal = InsonorisationLocalElement;

import { ReactComponent as InterversionElement } from './assets/Interversion_icons_Inversion_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Inversion } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Inversion variant="line" />
 * ```
 */
export const Interversion = InterversionElement;

import { ReactComponent as InterversionHeaderElement } from './assets/InterversionHeader_headers_Interversion.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Interversion } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Interversion  />
 * ```
 */
export const InterversionHeader = InterversionHeaderElement;

import { ReactComponent as ItalicElement } from './assets/Italic_icons_TextItalic_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TextItalic } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <TextItalic variant="line" />
 * ```
 */
export const Italic = ItalicElement;

import { ReactComponent as LeftArrowElement } from './assets/LeftArrow_icons_NavigateLeft_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateLeft } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateLeft variant="line" />
 * ```
 */
export const LeftArrow = LeftArrowElement;

import { ReactComponent as LeftArrowButtonElement } from './assets/LeftArrowButton_icons_NavigateLeft_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateLeft } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateLeft variant="line" />
 * ```
 */
export const LeftArrowButton = LeftArrowButtonElement;

import { ReactComponent as LightArrowElement } from './assets/LightArrow_icons_NavigateDown_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateDown } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateDown variant="line" />
 * ```
 */
export const LightArrow = LightArrowElement;

import { ReactComponent as LightPencilElement } from './assets/LightPencil_icons_Edit_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Edit } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Edit variant="line" />
 * ```
 */
export const LightPencil = LightPencilElement;

import { ReactComponent as LikeElement } from './assets/Like_icons_Like_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Like } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Like variant="fill" />
 * ```
 */
export const Like = LikeElement;

import { ReactComponent as LinkGreyElement } from './assets/LinkGrey_icons_Chain_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Chain } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Chain variant="line" />
 * ```
 */
export const LinkGrey = LinkGreyElement;

import { ReactComponent as LinkWhiteElement } from './assets/LinkWhite_icons_Chain_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Chain } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Chain variant="fill" />
 * ```
 */
export const LinkWhite = LinkWhiteElement;

import { ReactComponent as ListElement } from './assets/List_icons_List_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { List } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <List variant="line" />
 * ```
 */
export const List = ListElement;

import { ReactComponent as ListCardMoreElement } from './assets/ListCardMore_icons_Add_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Add } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Add variant="line" />
 * ```
 */
export const ListCardMore = ListCardMoreElement;

import { ReactComponent as ListCheckElement } from './assets/ListCheck_icons_ListCheck_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ListCheck } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <ListCheck variant="line" />
 * ```
 */
export const ListCheck = ListCheckElement;

import { ReactComponent as ListFillElement } from './assets/ListFill_icons_List_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { List } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <List variant="fill" />
 * ```
 */
export const ListFill = ListFillElement;

import { ReactComponent as ListIconElement } from './assets/ListIcon.svg';
/**
 * @deprecated this icon was not replaced
 */
export const ListIcon = ListIconElement;

import { ReactComponent as ListNumberElement } from './assets/ListNumber_icons_ListNumber_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ListNumber } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <ListNumber variant="line" />
 * ```
 */
export const ListNumber = ListNumberElement;

import { ReactComponent as ListeElement } from './assets/Liste_icons_List_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { List } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <List variant="line" />
 * ```
 */
export const Liste = ListeElement;

import { ReactComponent as LoadingElement } from './assets/Loading_icons_Loading_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Loading } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Loading variant="line" />
 * ```
 */
export const Loading = LoadingElement;

import { ReactComponent as LocationElement } from './assets/Location_icons_Marker_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Marker } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Marker variant="fill" />
 * ```
 */
export const Location = LocationElement;

import { ReactComponent as LockedElement } from './assets/Locked_icons_Locked_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Locked } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Locked variant="fill" />
 * ```
 */
export const Locked = LockedElement;

import { ReactComponent as LogistiqueElement } from './assets/Logistique_pictos_SecteurLogistique.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecteurLogistique } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecteurLogistique  />
 * ```
 */
export const Logistique = LogistiqueElement;

import { ReactComponent as LogoPigeElement } from './assets/LogoPige_logos_Flash_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Flash } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Flash variant="prod" />
 * ```
 */
export const LogoPige = LogoPigeElement;

import { ReactComponent as LoopGreyElement } from './assets/LoopGrey_icons_Refresh_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Refresh } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Refresh variant="line" />
 * ```
 */
export const LoopGrey = LoopGreyElement;

import { ReactComponent as LoopWhiteElement } from './assets/LoopWhite_icons_Refresh_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Refresh } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Refresh variant="fill" />
 * ```
 */
export const LoopWhite = LoopWhiteElement;

import { ReactComponent as LoupeElement } from './assets/Loupe_icons_Lens_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Lens } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Lens variant="line" />
 * ```
 */
export const Loupe = LoupeElement;

import { ReactComponent as LowVoltageElement } from './assets/LowVoltage_pictos_HabilitationElecH.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { HabilitationElecH } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <HabilitationElecH  />
 * ```
 */
export const LowVoltage = LowVoltageElement;

import { ReactComponent as LunettesElement } from './assets/Lunettes_pictos_SecuLunettes.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuLunettes } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuLunettes  />
 * ```
 */
export const Lunettes = LunettesElement;

import { ReactComponent as MasqueElement } from './assets/Masque_pictos_SecuMasque.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuMasque } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuMasque  />
 * ```
 */
export const Masque = MasqueElement;

import { ReactComponent as MedalElement } from './assets/Medal_pictos_Experience.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Experience } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Experience  />
 * ```
 */
export const Medal = MedalElement;

import { ReactComponent as MediumHistoElement } from './assets/MediumHisto_icons_SizeB_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SizeB } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <SizeB variant="line" />
 * ```
 */
export const MediumHisto = MediumHistoElement;

import { ReactComponent as MegaphoneElement } from './assets/Megaphone_icons_Megaphone_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Megaphone } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Megaphone variant="line" />
 * ```
 */
export const Megaphone = MegaphoneElement;

import { ReactComponent as MemoElement } from './assets/Memo_headers_Memo.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Memo } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <Memo  />
 * ```
 */
export const Memo = MemoElement;

import { ReactComponent as MenuElement } from './assets/Menu_icons_InterApp_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { InterApp } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <InterApp variant="fill" />
 * ```
 */
export const Menu = MenuElement;

import { ReactComponent as MicrophoneElement } from './assets/Microphone_icons_Microphone_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Microphone } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Microphone variant="line" />
 * ```
 */
export const Microphone = MicrophoneElement;

import { ReactComponent as MinusBarElement } from './assets/MinusBar_icons_Minus_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Minus } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Minus variant="line" />
 * ```
 */
export const MinusBar = MinusBarElement;

import { ReactComponent as MinusCloseElement } from './assets/MinusClose_icons_Minus_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Minus } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Minus variant="line" />
 * ```
 */
export const MinusClose = MinusCloseElement;

import { ReactComponent as MobileElement } from './assets/Mobile_icons_Mobile_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Mobile } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Mobile variant="line" />
 * ```
 */
export const Mobile = MobileElement;

import { ReactComponent as ModeleElement } from './assets/Modele.svg';
/**
 * @deprecated this icon was not replaced
 */
export const Modele = ModeleElement;

import { ReactComponent as MoinsCircleElement } from './assets/MoinsCircle_icons_CircleMinus_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleMinus } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleMinus variant="fill" />
 * ```
 */
export const MoinsCircle = MoinsCircleElement;

import { ReactComponent as NotebookElement } from './assets/Notebook.svg';
/**
 * @deprecated this icon was not replaced
 */
export const Notebook = NotebookElement;

import { ReactComponent as NotesElement } from './assets/Notes_icons_Sheet_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Sheet } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Sheet variant="fill" />
 * ```
 */
export const Notes = NotesElement;

import { ReactComponent as NotificationElement } from './assets/Notification_icons_Bell_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Bell } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Bell variant="fill" />
 * ```
 */
export const Notification = NotificationElement;

import { ReactComponent as OpenLockElement } from './assets/OpenLock_icons_Unlock_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Unlock } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Unlock variant="fill" />
 * ```
 */
export const OpenLock = OpenLockElement;

import { ReactComponent as POMIconElement } from './assets/POMIcon_logos_PortailMobilite_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PortailMobilite } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <PortailMobilite variant="prod" />
 * ```
 */
export const POMIcon = POMIconElement;

import { ReactComponent as POMMobileIconElement } from './assets/POMMobileIcon_logos_PortailMobilite_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PortailMobilite } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <PortailMobilite variant="prod" />
 * ```
 */
export const POMMobileIcon = POMMobileIconElement;

import { ReactComponent as POMUatIconElement } from './assets/POMUatIcon_logos_PortailMobilite_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PortailMobilite } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <PortailMobilite variant="uat" />
 * ```
 */
export const POMUatIcon = POMUatIconElement;

import { ReactComponent as POMUatMobileIconElement } from './assets/POMUatMobileIcon_logos_PortailMobilite_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PortailMobilite } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <PortailMobilite variant="uat" />
 * ```
 */
export const POMUatMobileIcon = POMUatMobileIconElement;

import { ReactComponent as PaperClipElement } from './assets/PaperClip_icons_Attachment_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Attachment } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Attachment variant="line" />
 * ```
 */
export const PaperClip = PaperClipElement;

import { ReactComponent as ParametersElement } from './assets/Parameters_icons_Settings_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Settings } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Settings variant="fill" />
 * ```
 */
export const Parameters = ParametersElement;

import { ReactComponent as PastequeElement } from './assets/Pasteque_illustrations_VidePasteque.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { VidePasteque } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
 *
 * <VidePasteque  />
 * ```
 */
export const Pasteque = PastequeElement;

import { ReactComponent as PencilElement } from './assets/Pencil_icons_Edit_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Edit } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Edit variant="fill" />
 * ```
 */
export const Pencil = PencilElement;

import { ReactComponent as PencilAndLineElement } from './assets/PencilAndLine_icons_Edit_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Edit } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Edit variant="fill" />
 * ```
 */
export const PencilAndLine = PencilAndLineElement;

import { ReactComponent as PeopleElement } from './assets/People_icons_People_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { People } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <People variant="fill" />
 * ```
 */
export const People = PeopleElement;

import { ReactComponent as PeopleAbsentElement } from './assets/PeopleAbsent_icons_PeopleMissing_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PeopleMissing } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <PeopleMissing variant="fill" />
 * ```
 */
export const PeopleAbsent = PeopleAbsentElement;

import { ReactComponent as PeopleIconElement } from './assets/PeopleIcon.svg';
/**
 * @deprecated this icon was not replaced
 */
export const PeopleIcon = PeopleIconElement;

import { ReactComponent as PercentElement } from './assets/Percent_icons_Percentage_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Percentage } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Percentage variant="line" />
 * ```
 */
export const Percent = PercentElement;

import { ReactComponent as PersonElement } from './assets/Person_icons_User_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { User } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <User variant="fill" />
 * ```
 */
export const Person = PersonElement;

import { ReactComponent as PersonSearchElement } from './assets/PersonSearch_icons_PeopleLens_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { PeopleLens } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <PeopleLens variant="fill" />
 * ```
 */
export const PersonSearch = PersonSearchElement;

import { ReactComponent as PharmaceutiqueElement } from './assets/Pharmaceutique_pictos_SecteurPharmaceutique.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecteurPharmaceutique } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecteurPharmaceutique  />
 * ```
 */
export const Pharmaceutique = PharmaceutiqueElement;

import { ReactComponent as PhoneElement } from './assets/Phone.svg';
/**
 * @deprecated this icon was not replaced
 */
export const Phone = PhoneElement;

import { ReactComponent as PhoneRoundElement } from './assets/PhoneRound.svg';
/**
 * @deprecated this icon was not replaced
 */
export const PhoneRound = PhoneRoundElement;

import { ReactComponent as PigeMobileIconElement } from './assets/PigeMobileIcon_logos_Pige_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Pige } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Pige variant="prod" />
 * ```
 */
export const PigeMobileIcon = PigeMobileIconElement;

import { ReactComponent as PigeProdElement } from './assets/PigeProd_logos_Pige_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Pige } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Pige variant="prod" />
 * ```
 */
export const PigeProd = PigeProdElement;

import { ReactComponent as PigeUATMobileElement } from './assets/PigeUATMobile_logos_Pige_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Pige } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Pige variant="uat" />
 * ```
 */
export const PigeUATMobile = PigeUATMobileElement;

import { ReactComponent as PigeUatElement } from './assets/PigeUat_logos_Pige_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Pige } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Pige variant="uat" />
 * ```
 */
export const PigeUat = PigeUatElement;

import { ReactComponent as PinLocateElement } from './assets/PinLocate_icons_Marker_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Marker } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Marker variant="fill" />
 * ```
 */
export const PinLocate = PinLocateElement;

import { ReactComponent as PinLocateLoupeElement } from './assets/PinLocateLoupe_icons_MarkerInd_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { MarkerInd } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <MarkerInd variant="fill" />
 * ```
 */
export const PinLocateLoupe = PinLocateLoupeElement;

import { ReactComponent as PinOutlineElement } from './assets/PinOutline_icons_Marker_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Marker } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Marker variant="line" />
 * ```
 */
export const PinOutline = PinOutlineElement;

import { ReactComponent as PinOutlineWhiteElement } from './assets/PinOutlineWhite_icons_Marker_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Marker } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Marker variant="line" />
 * ```
 */
export const PinOutlineWhite = PinOutlineWhiteElement;

import { ReactComponent as PlainCrossElement } from './assets/PlainCross_icons_CircleError_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleError } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleError variant="fill" />
 * ```
 */
export const PlainCross = PlainCrossElement;

import { ReactComponent as PlusCircleElement } from './assets/PlusCircle_icons_CircleAdd_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleAdd } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleAdd variant="fill" />
 * ```
 */
export const PlusCircle = PlusCircleElement;

import { ReactComponent as PlusInCircleElement } from './assets/PlusInCircle_icons_CircleAdd_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleAdd } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleAdd variant="line" />
 * ```
 */
export const PlusInCircle = PlusInCircleElement;

import { ReactComponent as PlusOpenElement } from './assets/PlusOpen_icons_Add_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Add } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Add variant="line" />
 * ```
 */
export const PlusOpen = PlusOpenElement;

import { ReactComponent as PlusWithWhiteBackElement } from './assets/PlusWithWhiteBack_icons_CircleAdd_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleAdd } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleAdd variant="fill" />
 * ```
 */
export const PlusWithWhiteBack = PlusWithWhiteBackElement;

import { ReactComponent as PoigneeLateraleCamionElement } from './assets/PoigneeLateraleCamion_pictos_SecuPoigneeLateraleCamion.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuPoigneeLateraleCamion } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuPoigneeLateraleCamion  />
 * ```
 */
export const PoigneeLateraleCamion = PoigneeLateraleCamionElement;

import { ReactComponent as PoigneeVibratileElement } from './assets/PoigneeVibratile_pictos_SecuPoigneeVibratile.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuPoigneeVibratile } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuPoigneeVibratile  />
 * ```
 */
export const PoigneeVibratile = PoigneeVibratileElement;

import { ReactComponent as PointerElement } from './assets/Pointer_icons_HandUp_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { HandUp } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <HandUp variant="fill" />
 * ```
 */
export const Pointer = PointerElement;

import { ReactComponent as PointingFingerCutElement } from './assets/PointingFingerCut_headers_ActionBlue.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ActionBlue } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
 *
 * <ActionBlue  />
 * ```
 */
export const PointingFingerCut = PointingFingerCutElement;

import { ReactComponent as PreferencesElement } from './assets/Preferences_icons_Parameters_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Parameters } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Parameters variant="line" />
 * ```
 */
export const Preferences = PreferencesElement;

import { ReactComponent as PublicElement } from './assets/Public_pictos_Publique.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Publique } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Publique  />
 * ```
 */
export const Public = PublicElement;

import { ReactComponent as PuzzleMobileIconElement } from './assets/PuzzleMobileIcon_logos_Puzzle_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Puzzle } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Puzzle variant="prod" />
 * ```
 */
export const PuzzleMobileIcon = PuzzleMobileIconElement;

import { ReactComponent as PuzzleProdElement } from './assets/PuzzleProd_logos_Puzzle_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Puzzle } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Puzzle variant="prod" />
 * ```
 */
export const PuzzleProd = PuzzleProdElement;

import { ReactComponent as PuzzleUATMobileElement } from './assets/PuzzleUATMobile_logos_Puzzle_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Puzzle } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Puzzle variant="uat" />
 * ```
 */
export const PuzzleUATMobile = PuzzleUATMobileElement;

import { ReactComponent as PuzzleUatElement } from './assets/PuzzleUat_logos_Puzzle_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Puzzle } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Puzzle variant="uat" />
 * ```
 */
export const PuzzleUat = PuzzleUatElement;

import { ReactComponent as RLMobileIconElement } from './assets/RLMobileIcon_logos_Recrutlive_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Recrutlive } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Recrutlive variant="prod" />
 * ```
 */
export const RLMobileIcon = RLMobileIconElement;

import { ReactComponent as RLUATMobileElement } from './assets/RLUATMobile_logos_Recrutlive_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Recrutlive } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Recrutlive variant="uat" />
 * ```
 */
export const RLUATMobile = RLUATMobileElement;

import { ReactComponent as RadioButtonCheckElement } from './assets/RadioButtonCheck.svg';
/**
 * @deprecated this icon was not replaced
 */
export const RadioButtonCheck = RadioButtonCheckElement;

import { ReactComponent as RadioButtonEmptyElement } from './assets/RadioButtonEmpty.svg';
/**
 * @deprecated this icon was not replaced
 */
export const RadioButtonEmpty = RadioButtonEmptyElement;

import { ReactComponent as RandstadElement } from './assets/Randstad_icons_Randstad_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Randstad } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Randstad variant="line" />
 * ```
 */
export const Randstad = RandstadElement;

import { ReactComponent as RandstadDiskElement } from './assets/RandstadDisk_icons_RandstadCircle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RandstadCircle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <RandstadCircle variant="fill" />
 * ```
 */
export const RandstadDisk = RandstadDiskElement;

import { ReactComponent as RandstadGreyElement } from './assets/RandstadGrey_icons_RandstadCircle_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RandstadCircle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <RandstadCircle variant="line" />
 * ```
 */
export const RandstadGrey = RandstadGreyElement;

import { ReactComponent as RandstadIconElement } from './assets/RandstadIcon_icons_RandstadCircle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RandstadCircle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <RandstadCircle variant="fill" />
 * ```
 */
export const RandstadIcon = RandstadIconElement;

import { ReactComponent as RandstadLogoElement } from './assets/RandstadLogo_brandLogos_Randstad.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Randstad } from '@randstad-lean-mobile-factory/react-assets/dist/brandLogos';
 *
 * <Randstad  />
 * ```
 */
export const RandstadLogo = RandstadLogoElement;

import { ReactComponent as RandstadWhiteElement } from './assets/RandstadWhite_icons_RandstadCircle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RandstadCircle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <RandstadCircle variant="fill" />
 * ```
 */
export const RandstadWhite = RandstadWhiteElement;

import { ReactComponent as RecrutLiveIconElement } from './assets/RecrutLiveIcon_logos_Recrutlive_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Recrutlive } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Recrutlive variant="prod" />
 * ```
 */
export const RecrutLiveIcon = RecrutLiveIconElement;

import { ReactComponent as RecrutLiveProdElement } from './assets/RecrutLiveProd_logos_Recrutlive_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Recrutlive } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Recrutlive variant="uat" />
 * ```
 */
export const RecrutLiveProd = RecrutLiveProdElement;

import { ReactComponent as RecrutLiveUatElement } from './assets/RecrutLiveUat_logos_Recrutlive_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Recrutlive } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Recrutlive variant="uat" />
 * ```
 */
export const RecrutLiveUat = RecrutLiveUatElement;

import { ReactComponent as RedBulletElement } from './assets/RedBullet_icons_Bullet_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Bullet } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Bullet variant="fill" />
 * ```
 */
export const RedBullet = RedBulletElement;

import { ReactComponent as RedChipElement } from './assets/RedChip_icons_Circle_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Circle } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Circle variant="fill" />
 * ```
 */
export const RedChip = RedChipElement;

import { ReactComponent as RefreshElement } from './assets/Refresh_icons_Refresh_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Refresh } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Refresh variant="line" />
 * ```
 */
export const Refresh = RefreshElement;

import { ReactComponent as RenameFieldElement } from './assets/RenameField_icons_Rename_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Rename } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Rename variant="line" />
 * ```
 */
export const RenameField = RenameFieldElement;

import { ReactComponent as ReundoElement } from './assets/Reundo_icons_Redo_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Redo } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Redo variant="line" />
 * ```
 */
export const Reundo = ReundoElement;

import { ReactComponent as RightArrowElement } from './assets/RightArrow_icons_NavigateRight_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateRight } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateRight variant="line" />
 * ```
 */
export const RightArrow = RightArrowElement;

import { ReactComponent as RightArrowButtonElement } from './assets/RightArrowButton_icons_NavigateRight_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateRight } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateRight variant="line" />
 * ```
 */
export const RightArrowButton = RightArrowButtonElement;

import { ReactComponent as RiskAtmoExplosifElement } from './assets/RiskAtmoExplosif_pictos_RisqueAtmoExplosif.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueAtmoExplosif } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueAtmoExplosif  />
 * ```
 */
export const RiskAtmoExplosif = RiskAtmoExplosifElement;

import { ReactComponent as RiskBruitElement } from './assets/RiskBruit_pictos_RisqueBruit.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueBruit } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueBruit  />
 * ```
 */
export const RiskBruit = RiskBruitElement;

import { ReactComponent as RiskChimiqueElement } from './assets/RiskChimique_pictos_RisqueChimique.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueChimique } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueChimique  />
 * ```
 */
export const RiskChimique = RiskChimiqueElement;

import { ReactComponent as RiskChuteElement } from './assets/RiskChute_pictos_RisqueChimique.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueChimique } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueChimique  />
 * ```
 */
export const RiskChute = RiskChuteElement;

import { ReactComponent as RiskConfinElement } from './assets/RiskConfin_pictos_RisqueConfine.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueConfine } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueConfine  />
 * ```
 */
export const RiskConfin = RiskConfinElement;

import { ReactComponent as RiskElectricitElement } from './assets/RiskElectricit_pictos_RisqueElectricite.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueElectricite } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueElectricite  />
 * ```
 */
export const RiskElectricit = RiskElectricitElement;

import { ReactComponent as RiskFibreAmianteElement } from './assets/RiskFibreAmiante_pictos_RisqueFibreAmiante.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueFibreAmiante } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueFibreAmiante  />
 * ```
 */
export const RiskFibreAmiante = RiskFibreAmianteElement;

import { ReactComponent as RiskMachineProductionElement } from './assets/RiskMachineProduction_pictos_RisqueMachineProduction.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueMachineProduction } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueMachineProduction  />
 * ```
 */
export const RiskMachineProduction = RiskMachineProductionElement;

import { ReactComponent as RiskManutentionManuelleElement } from './assets/RiskManutentionManuelle_pictos_RisqueManutentionManuelle.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueManutentionManuelle } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueManutentionManuelle  />
 * ```
 */
export const RiskManutentionManuelle = RiskManutentionManuelleElement;

import { ReactComponent as RiskOutilsMaterielsElectroportatifsElement } from './assets/RiskOutilsMaterielsElectroportatifs_pictos_RisqueOutilsMaterielsElectroportatifs.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueOutilsMaterielsElectroportatifs } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueOutilsMaterielsElectroportatifs  />
 * ```
 */
export const RiskOutilsMaterielsElectroportatifs = RiskOutilsMaterielsElectroportatifsElement;

import { ReactComponent as RiskPontRoulantElement } from './assets/RiskPontRoulant_pictos_RisquePontRoulant.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisquePontRoulant } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisquePontRoulant  />
 * ```
 */
export const RiskPontRoulant = RiskPontRoulantElement;

import { ReactComponent as RiskPoussiereElement } from './assets/RiskPoussiere_pictos_RisquePoussiere.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisquePoussiere } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisquePoussiere  />
 * ```
 */
export const RiskPoussiere = RiskPoussiereElement;

import { ReactComponent as RiskRayonnementElement } from './assets/RiskRayonnement_pictos_RisqueRayonnement.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueRayonnement } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueRayonnement  />
 * ```
 */
export const RiskRayonnement = RiskRayonnementElement;

import { ReactComponent as RiskRoutierElement } from './assets/RiskRoutier_pictos_RisqueRoutier.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueRoutier } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueRoutier  />
 * ```
 */
export const RiskRoutier = RiskRoutierElement;

import { ReactComponent as RiskStockageChimiqueElement } from './assets/RiskStockageChimique_pictos_RisqueStockageChimique.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueStockageChimique } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueStockageChimique  />
 * ```
 */
export const RiskStockageChimique = RiskStockageChimiqueElement;

import { ReactComponent as RiskStockageMateriauxElement } from './assets/RiskStockageMateriaux_pictos_RisqueStockageMateriaux.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueStockageMateriaux } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueStockageMateriaux  />
 * ```
 */
export const RiskStockageMateriaux = RiskStockageMateriauxElement;

import { ReactComponent as RiskTemperatureElement } from './assets/RiskTemperature_pictos_RisqueTemperature.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueTemperature } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueTemperature  />
 * ```
 */
export const RiskTemperature = RiskTemperatureElement;

import { ReactComponent as RiskTravailEchafaudageElement } from './assets/RiskTravailEchafaudage_pictos_RisqueTravailEchafaudage.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueTravailEchafaudage } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueTravailEchafaudage  />
 * ```
 */
export const RiskTravailEchafaudage = RiskTravailEchafaudageElement;

import { ReactComponent as RiskTravailEnginsChantierElement } from './assets/RiskTravailEnginsChantier_pictos_RisqueTravailEnginsChantier.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueTravailEnginsChantier } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueTravailEnginsChantier  />
 * ```
 */
export const RiskTravailEnginsChantier = RiskTravailEnginsChantierElement;

import { ReactComponent as RiskTravailEnginsMouvementElement } from './assets/RiskTravailEnginsMouvement_pictos_RisqueTravailEnginsChantier.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueTravailEnginsChantier } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueTravailEnginsChantier  />
 * ```
 */
export const RiskTravailEnginsMouvement = RiskTravailEnginsMouvementElement;

import { ReactComponent as RiskTravailExterieurElement } from './assets/RiskTravailExterieur_pictos_RisqueTravailExterieur.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueTravailExterieur } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueTravailExterieur  />
 * ```
 */
export const RiskTravailExterieur = RiskTravailExterieurElement;

import { ReactComponent as RiskTravailHauteurElement } from './assets/RiskTravailHauteur_pictos_RisqueTravailHauteur.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueTravailHauteur } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueTravailHauteur  />
 * ```
 */
export const RiskTravailHauteur = RiskTravailHauteurElement;

import { ReactComponent as RiskTravailIsolElement } from './assets/RiskTravailIsol_pictos_RisqueTravailNuit.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueTravailNuit } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueTravailNuit  />
 * ```
 */
export const RiskTravailIsol = RiskTravailIsolElement;

import { ReactComponent as RiskVibrationElement } from './assets/RiskVibration_pictos_RisqueVibration.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { RisqueVibration } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <RisqueVibration  />
 * ```
 */
export const RiskVibration = RiskVibrationElement;

import { ReactComponent as SatisfactionMobileElement } from './assets/SatisfactionMobile_logos_Satisfaction_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Satisfaction } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Satisfaction variant="prod" />
 * ```
 */
export const SatisfactionMobile = SatisfactionMobileElement;

import { ReactComponent as SatisfactionProdElement } from './assets/SatisfactionProd_logos_Satisfaction_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Satisfaction } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Satisfaction variant="prod" />
 * ```
 */
export const SatisfactionProd = SatisfactionProdElement;

import { ReactComponent as SatisfactionUATMobileElement } from './assets/SatisfactionUATMobile_logos_Satisfaction_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Satisfaction } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Satisfaction variant="uat" />
 * ```
 */
export const SatisfactionUATMobile = SatisfactionUATMobileElement;

import { ReactComponent as SatisfactionUatElement } from './assets/SatisfactionUat_logos_Satisfaction_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Satisfaction } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Satisfaction variant="uat" />
 * ```
 */
export const SatisfactionUat = SatisfactionUatElement;

import { ReactComponent as ScopeProdElement } from './assets/ScopeProd_logos_Scope_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Scope } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Scope variant="prod" />
 * ```
 */
export const ScopeProd = ScopeProdElement;

import { ReactComponent as ScopeUatElement } from './assets/ScopeUat_logos_Scope_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Scope } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <Scope variant="uat" />
 * ```
 */
export const ScopeUat = ScopeUatElement;

import { ReactComponent as SearchElement } from './assets/Search_icons_Lens_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Lens } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Lens variant="line" />
 * ```
 */
export const Search = SearchElement;

import { ReactComponent as SecuriteElement } from './assets/Securite.svg';
/**
 * @deprecated this icon was not replaced
 */
export const Securite = SecuriteElement;

import { ReactComponent as SendElement } from './assets/Send_icons_Send_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Send } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Send variant="fill" />
 * ```
 */
export const Send = SendElement;

import { ReactComponent as ServiceElement } from './assets/Service_pictos_SecteurServices.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecteurServices } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecteurServices  />
 * ```
 */
export const Service = ServiceElement;

import { ReactComponent as ServiceSearchElement } from './assets/ServiceSearch_icons_MarkerInd_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { MarkerInd } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <MarkerInd variant="fill" />
 * ```
 */
export const ServiceSearch = ServiceSearchElement;

import { ReactComponent as ShareElement } from './assets/Share_icons_Export_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Export } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Export variant="line" />
 * ```
 */
export const Share = ShareElement;

import { ReactComponent as SignatureElement } from './assets/Signature_icons_Signature_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Signature } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Signature variant="line" />
 * ```
 */
export const Signature = SignatureElement;

import { ReactComponent as SimpleBodyBlueElement } from './assets/SimpleBodyBlue_icons_User_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { User } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <User variant="fill" />
 * ```
 */
export const SimpleBodyBlue = SimpleBodyBlueElement;

import { ReactComponent as SimpleBodyGreyElement } from './assets/SimpleBodyGrey_icons_User_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { User } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <User variant="line" />
 * ```
 */
export const SimpleBodyGrey = SimpleBodyGreyElement;

import { ReactComponent as SmallHistoElement } from './assets/SmallHisto_icons_SizeA_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SizeA } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <SizeA variant="line" />
 * ```
 */
export const SmallHisto = SmallHistoElement;

import { ReactComponent as SmsElement } from './assets/Sms_icons_CommentsChat_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CommentsChat } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CommentsChat variant="fill" />
 * ```
 */
export const Sms = SmsElement;

import { ReactComponent as SmsRoundElement } from './assets/SmsRound.svg';
/**
 * @deprecated this icon was not replaced
 */
export const SmsRound = SmsRoundElement;

import { ReactComponent as SolAntiderapantElement } from './assets/SolAntiderapant_pictos_SecuSolAntideprapant.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuSolAntideprapant } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuSolAntideprapant  />
 * ```
 */
export const SolAntiderapant = SolAntiderapantElement;

import { ReactComponent as SortElement } from './assets/Sort_icons_SortDescending_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SortDescending } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <SortDescending variant="line" />
 * ```
 */
export const Sort = SortElement;

import { ReactComponent as StopInCircleElement } from './assets/StopInCircle_icons_Stop_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Stop } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Stop variant="line" />
 * ```
 */
export const StopInCircle = StopInCircleElement;

import { ReactComponent as StopRollElement } from './assets/StopRoll_pictos_SecuStopRoll.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuStopRoll } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuStopRoll  />
 * ```
 */
export const StopRoll = StopRollElement;

import { ReactComponent as StraightBurgerMenuElement } from './assets/StraightBurgerMenu_icons_BurgerMenu_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { BurgerMenu } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <BurgerMenu variant="line" />
 * ```
 */
export const StraightBurgerMenu = StraightBurgerMenuElement;

import { ReactComponent as StyloElement } from './assets/Stylo_pictos_Contrats.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Contrats } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <Contrats  />
 * ```
 */
export const Stylo = StyloElement;

import { ReactComponent as SynchroElement } from './assets/Synchro_icons_Refresh_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Refresh } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Refresh variant="line" />
 * ```
 */
export const Synchro = SynchroElement;

import { ReactComponent as TDPMobileIconElement } from './assets/TDPMobileIcon_logos_TourDeProd_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TourDeProd } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <TourDeProd variant="prod" />
 * ```
 */
export const TDPMobileIcon = TDPMobileIconElement;

import { ReactComponent as TDPProdElement } from './assets/TDPProd_logos_TourDeProd_prod.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TourDeProd } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <TourDeProd variant="prod" />
 * ```
 */
export const TDPProd = TDPProdElement;

import { ReactComponent as TDPUATMobileElement } from './assets/TDPUATMobile_logos_TourDeProd_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TourDeProd } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <TourDeProd variant="uat" />
 * ```
 */
export const TDPUATMobile = TDPUATMobileElement;

import { ReactComponent as TDPUatElement } from './assets/TDPUat_logos_TourDeProd_uat.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TourDeProd } from '@randstad-lean-mobile-factory/react-assets/dist/logos';
 *
 * <TourDeProd variant="uat" />
 * ```
 */
export const TDPUat = TDPUatElement;

import { ReactComponent as TabletteElement } from './assets/Tablette.svg';
/**
 * @deprecated this icon was not replaced
 */
export const Tablette = TabletteElement;

import { ReactComponent as TapisSensibleElement } from './assets/TapisSensible_pictos_SecuTapisSensible.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuTapisSensible } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuTapisSensible  />
 * ```
 */
export const TapisSensible = TapisSensibleElement;

import { ReactComponent as TargetElement } from './assets/Target_icons_Target_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Target } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Target variant="line" />
 * ```
 */
export const Target = TargetElement;

import { ReactComponent as TelephoneElement } from './assets/Telephone_icons_Telephone_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Telephone } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Telephone variant="fill" />
 * ```
 */
export const Telephone = TelephoneElement;

import { ReactComponent as TextElement } from './assets/Text_icons_Document_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Document } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Document variant="line" />
 * ```
 */
export const Text = TextElement;

import { ReactComponent as ThreeDotsElement } from './assets/ThreeDots_icons_OtherHorizontal_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { OtherHorizontal } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <OtherHorizontal variant="fill" />
 * ```
 */
export const ThreeDots = ThreeDotsElement;

import { ReactComponent as ThreeDotsOtherElement } from './assets/ThreeDotsOther_icons_OtherHorizontal_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { OtherHorizontal } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <OtherHorizontal variant="line" />
 * ```
 */
export const ThreeDotsOther = ThreeDotsOtherElement;

import { ReactComponent as ThreeDotsXLElement } from './assets/ThreeDotsXL_icons_OtherHorizontal_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { OtherHorizontal } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <OtherHorizontal variant="line" />
 * ```
 */
export const ThreeDotsXL = ThreeDotsXLElement;

import { ReactComponent as ThunderElement } from './assets/Thunder_icons_Shortcuts_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Shortcuts } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Shortcuts variant="fill" />
 * ```
 */
export const Thunder = ThunderElement;

import { ReactComponent as ThunderLineElement } from './assets/ThunderLine_icons_Shortcuts_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Shortcuts } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Shortcuts variant="line" />
 * ```
 */
export const ThunderLine = ThunderLineElement;

import { ReactComponent as TickElement } from './assets/Tick_icons_Check_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Check } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Check variant="line" />
 * ```
 */
export const Tick = TickElement;

import { ReactComponent as TickCircleGreenElement } from './assets/TickCircleGreen_icons_CircleCheck_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleCheck } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleCheck variant="fill" />
 * ```
 */
export const TickCircleGreen = TickCircleGreenElement;

import { ReactComponent as TimingElement } from './assets/Timing_icons_Timing_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Timing } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Timing variant="line" />
 * ```
 */
export const Timing = TimingElement;

import { ReactComponent as ToolsElement } from './assets/Tools_icons_Tools_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Tools } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Tools variant="line" />
 * ```
 */
export const Tools = ToolsElement;

import { ReactComponent as TrashcanElement } from './assets/Trashcan_icons_Dustbin_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Dustbin } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Dustbin variant="line" />
 * ```
 */
export const Trashcan = TrashcanElement;

import { ReactComponent as UnderConstructionElement } from './assets/UnderConstruction.svg';
/**
 * @deprecated this icon was not replaced
 */
export const UnderConstruction = UnderConstructionElement;

import { ReactComponent as UnderlineElement } from './assets/Underline_icons_TextUnderline_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { TextUnderline } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <TextUnderline variant="line" />
 * ```
 */
export const Underline = UnderlineElement;

import { ReactComponent as UndoElement } from './assets/Undo_icons_Undo_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Undo } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Undo variant="line" />
 * ```
 */
export const Undo = UndoElement;

import { ReactComponent as UpArrowElement } from './assets/UpArrow_icons_NavigateUp_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateUp } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateUp variant="line" />
 * ```
 */
export const UpArrow = UpArrowElement;

import { ReactComponent as UpWhiteArrowElement } from './assets/UpWhiteArrow_icons_CircleTop_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleTop } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleTop variant="fill" />
 * ```
 */
export const UpWhiteArrow = UpWhiteArrowElement;

import { ReactComponent as UploadCloudElement } from './assets/UploadCloud_icons_CloudUpload_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CloudUpload } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CloudUpload variant="fill" />
 * ```
 */
export const UploadCloud = UploadCloudElement;

import { ReactComponent as UploadCloudOutlineElement } from './assets/UploadCloudOutline_icons_CloudUpload_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CloudUpload } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CloudUpload variant="line" />
 * ```
 */
export const UploadCloudOutline = UploadCloudOutlineElement;

import { ReactComponent as UppercaseElement } from './assets/Uppercase.svg';
/**
 * @deprecated this icon was not replaced
 */
export const Uppercase = UppercaseElement;

import { ReactComponent as UserElement } from './assets/User_icons_User_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { User } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <User variant="fill" />
 * ```
 */
export const User = UserElement;

import { ReactComponent as UserPlusLineElement } from './assets/UserPlusLine_icons_UserAdd_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { UserAdd } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <UserAdd variant="line" />
 * ```
 */
export const UserPlusLine = UserPlusLineElement;

import { ReactComponent as VentilationElement } from './assets/Ventilation_pictos_SecuVentilation.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuVentilation } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuVentilation  />
 * ```
 */
export const Ventilation = VentilationElement;

import { ReactComponent as VersionElement } from './assets/Version_icons_Version_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Version } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Version variant="line" />
 * ```
 */
export const Version = VersionElement;

import { ReactComponent as VerticalBarElement } from './assets/VerticalBar.svg';
/**
 * @deprecated this icon was not replaced
 */
export const VerticalBar = VerticalBarElement;

import { ReactComponent as VerticalLongBarElement } from './assets/VerticalLongBar.svg';
/**
 * @deprecated this icon was not replaced
 */
export const VerticalLongBar = VerticalLongBarElement;

import { ReactComponent as ViewBigElement } from './assets/ViewBig_icons_ViewBandHorizontal_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { ViewBandHorizontal } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <ViewBandHorizontal variant="line" />
 * ```
 */
export const ViewBig = ViewBigElement;

import { ReactComponent as VisiteElement } from './assets/Visite_icons_Briefcase_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Briefcase } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Briefcase variant="fill" />
 * ```
 */
export const Visite = VisiteElement;

import { ReactComponent as VoieCirculationElement } from './assets/VoieCirculation_pictos_SecuVoieCirculation.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { SecuVoieCirculation } from '@randstad-lean-mobile-factory/react-assets/dist/pictos';
 *
 * <SecuVoieCirculation  />
 * ```
 */
export const VoieCirculation = VoieCirculationElement;

import { ReactComponent as WarningElement } from './assets/Warning_icons_Danger_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Danger } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Danger variant="fill" />
 * ```
 */
export const Warning = WarningElement;

import { ReactComponent as WarningRedElement } from './assets/WarningRed_icons_Danger_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Danger } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Danger variant="line" />
 * ```
 */
export const WarningRed = WarningRedElement;

import { ReactComponent as WhiteCheckElement } from './assets/WhiteCheck_icons_Check_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Check } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Check variant="line" />
 * ```
 */
export const WhiteCheck = WhiteCheckElement;

import { ReactComponent as WhiteCheckmarkCircleElement } from './assets/WhiteCheckmarkCircle_icons_CircleCheck_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleCheck } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleCheck variant="fill" />
 * ```
 */
export const WhiteCheckmarkCircle = WhiteCheckmarkCircleElement;

import { ReactComponent as WhiteCircleBottomArrowElement } from './assets/WhiteCircleBottomArrow_icons_CircleBottom_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleBottom } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleBottom variant="fill" />
 * ```
 */
export const WhiteCircleBottomArrow = WhiteCircleBottomArrowElement;

import { ReactComponent as WhiteCircleCrossElement } from './assets/WhiteCircleCross_icons_CircleError_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleError } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleError variant="line" />
 * ```
 */
export const WhiteCircleCross = WhiteCircleCrossElement;

import { ReactComponent as WhiteCirclePlusElement } from './assets/WhiteCirclePlus_icons_CircleAdd_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleAdd } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleAdd variant="fill" />
 * ```
 */
export const WhiteCirclePlus = WhiteCirclePlusElement;

import { ReactComponent as WhiteCirclePlusEmptyElement } from './assets/WhiteCirclePlusEmpty_icons_CircleAdd_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleAdd } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleAdd variant="line" />
 * ```
 */
export const WhiteCirclePlusEmpty = WhiteCirclePlusEmptyElement;

import { ReactComponent as WhiteCrossElement } from './assets/WhiteCross_icons_Close_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Close } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Close variant="line" />
 * ```
 */
export const WhiteCross = WhiteCrossElement;

import { ReactComponent as WhiteDashElement } from './assets/WhiteDash_icons_Minus_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Minus } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Minus variant="line" />
 * ```
 */
export const WhiteDash = WhiteDashElement;

import { ReactComponent as WhiteDashboardElement } from './assets/WhiteDashboard_icons_Indicator_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Indicator } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Indicator variant="line" />
 * ```
 */
export const WhiteDashboard = WhiteDashboardElement;

import { ReactComponent as WhiteDownArrowElement } from './assets/WhiteDownArrow_icons_NavigateDown_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateDown } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateDown variant="line" />
 * ```
 */
export const WhiteDownArrow = WhiteDownArrowElement;

import { ReactComponent as WhiteRightArrowElement } from './assets/WhiteRightArrow_icons_NavigateRight_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { NavigateRight } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <NavigateRight variant="line" />
 * ```
 */
export const WhiteRightArrow = WhiteRightArrowElement;

import { ReactComponent as WifiElement } from './assets/Wifi_icons_Area_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Area } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Area variant="line" />
 * ```
 */
export const Wifi = WifiElement;

import { ReactComponent as WrongElement } from './assets/Wrong_icons_Close_line.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { Close } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <Close variant="line" />
 * ```
 */
export const Wrong = WrongElement;

import { ReactComponent as WrongCircleElement } from './assets/WrongCircle_icons_CircleError_fill.svg';
/**
 * @deprecated use the following icon instead:
 * ```tsx
 * import { CircleError } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *
 * <CircleError variant="fill" />
 * ```
 */
export const WrongCircle = WrongCircleElement;
